/**
 * Generated from BronteSistersCutouts.fla
 */
export function BronteSistersCutouts(this: IBronteSistersCutouts) {
	const cutouts = this.cutouts;
	if (!cutouts[0] && cutouts.elementFactory) {
		cutouts[0] = cutouts.elementFactory(0,undefined);
	}
	if (cutouts[0]) {
		BronteSistersCutouts_broYCostume31.call(cutouts[0] as IBronteSistersCutouts_broYCostume31);
		cutouts[0].x = 740;
		cutouts[0].y = 420.5;
		if (cutouts[0].onLayout) cutouts[0].onLayout();
	}
	if (!cutouts[1] && cutouts.elementFactory) {
		cutouts[1] = cutouts.elementFactory(1,undefined);
	}
	if (cutouts[1]) {
		BronteSistersCutouts_broYCostume21.call(cutouts[1] as IBronteSistersCutouts_broYCostume21);
		cutouts[1].x = 739.5;
		cutouts[1].y = 443.5;
		if (cutouts[1].onLayout) cutouts[1].onLayout();
	}
	if (!cutouts[2] && cutouts.elementFactory) {
		cutouts[2] = cutouts.elementFactory(2,undefined);
	}
	if (cutouts[2]) {
		BronteSistersCutouts_broYCostume11.call(cutouts[2] as IBronteSistersCutouts_broYCostume11);
		cutouts[2].x = 737.5;
		cutouts[2].y = 463;
		if (cutouts[2].onLayout) cutouts[2].onLayout();
	}
	if (!cutouts[3] && cutouts.elementFactory) {
		cutouts[3] = cutouts.elementFactory(3,undefined);
	}
	if (cutouts[3]) {
		BronteSistersCutouts_broYCostume01.call(cutouts[3] as IBronteSistersCutouts_broYCostume01);
		cutouts[3].x = 733;
		cutouts[3].y = 329;
		if (cutouts[3].onLayout) cutouts[3].onLayout();
	}
	if (!cutouts[4] && cutouts.elementFactory) {
		cutouts[4] = cutouts.elementFactory(4,undefined);
	}
	if (cutouts[4]) {
		BronteSistersCutouts_broXCostume31.call(cutouts[4] as IBronteSistersCutouts_broXCostume31);
		cutouts[4].x = 737.5;
		cutouts[4].y = 392;
		if (cutouts[4].onLayout) cutouts[4].onLayout();
	}
	if (!cutouts[5] && cutouts.elementFactory) {
		cutouts[5] = cutouts.elementFactory(5,undefined);
	}
	if (cutouts[5]) {
		BronteSistersCutouts_broXCostume21.call(cutouts[5] as IBronteSistersCutouts_broXCostume21);
		cutouts[5].x = 812;
		cutouts[5].y = 421.5;
		if (cutouts[5].onLayout) cutouts[5].onLayout();
	}
	if (!cutouts[6] && cutouts.elementFactory) {
		cutouts[6] = cutouts.elementFactory(6,undefined);
	}
	if (cutouts[6]) {
		BronteSistersCutouts_broXCostume11.call(cutouts[6] as IBronteSistersCutouts_broXCostume11);
		cutouts[6].x = 763;
		cutouts[6].y = 384.5;
		if (cutouts[6].onLayout) cutouts[6].onLayout();
	}
	if (!cutouts[7] && cutouts.elementFactory) {
		cutouts[7] = cutouts.elementFactory(7,undefined);
	}
	if (cutouts[7]) {
		BronteSistersCutouts_broXCostume01.call(cutouts[7] as IBronteSistersCutouts_broXCostume01);
		cutouts[7].x = 830;
		cutouts[7].y = 393;
		if (cutouts[7].onLayout) cutouts[7].onLayout();
	}
	if (!cutouts[8] && cutouts.elementFactory) {
		cutouts[8] = cutouts.elementFactory(8,undefined);
	}
	if (cutouts[8]) {
		BronteSistersCutouts_broFloorRock21.call(cutouts[8] as IBronteSistersCutouts_broFloorRock21);
		cutouts[8].x = 790.5;
		cutouts[8].y = 710;
		if (cutouts[8].onLayout) cutouts[8].onLayout();
	}
	if (!cutouts[9] && cutouts.elementFactory) {
		cutouts[9] = cutouts.elementFactory(9,undefined);
	}
	if (cutouts[9]) {
		BronteSistersCutouts_broFloorRock11.call(cutouts[9] as IBronteSistersCutouts_broFloorRock11);
		cutouts[9].x = 801;
		cutouts[9].y = 710;
		if (cutouts[9].onLayout) cutouts[9].onLayout();
	}
	if (!cutouts[10] && cutouts.elementFactory) {
		cutouts[10] = cutouts.elementFactory(10,undefined);
	}
	if (cutouts[10]) {
		BronteSistersCutouts_broFloorRock01.call(cutouts[10] as IBronteSistersCutouts_broFloorRock01);
		cutouts[10].x = 790.5;
		cutouts[10].y = 710;
		if (cutouts[10].onLayout) cutouts[10].onLayout();
	}
	if (!cutouts[11] && cutouts.elementFactory) {
		cutouts[11] = cutouts.elementFactory(11,undefined);
	}
	if (cutouts[11]) {
		BronteSistersCutouts_broFloorQuicksand1.call(cutouts[11] as IBronteSistersCutouts_broFloorQuicksand1);
		cutouts[11].x = 173;
		cutouts[11].y = 591;
		if (cutouts[11].onLayout) cutouts[11].onLayout();
	}
	if (!cutouts[12] && cutouts.elementFactory) {
		cutouts[12] = cutouts.elementFactory(12,undefined);
	}
	if (cutouts[12]) {
		BronteSistersCutouts_broFloorPudding1.call(cutouts[12] as IBronteSistersCutouts_broFloorPudding1);
		cutouts[12].x = 192;
		cutouts[12].y = 611.5;
		if (cutouts[12].onLayout) cutouts[12].onLayout();
	}
	if (!cutouts[13] && cutouts.elementFactory) {
		cutouts[13] = cutouts.elementFactory(13,undefined);
	}
	if (cutouts[13]) {
		BronteSistersCutouts_broFloorLava1.call(cutouts[13] as IBronteSistersCutouts_broFloorLava1);
		cutouts[13].x = 192;
		cutouts[13].y = 633;
		if (cutouts[13].onLayout) cutouts[13].onLayout();
	}
	if (!cutouts[14] && cutouts.elementFactory) {
		cutouts[14] = cutouts.elementFactory(14,undefined);
	}
	if (cutouts[14]) {
		BronteSistersCutouts_broFloorIce1.call(cutouts[14] as IBronteSistersCutouts_broFloorIce1);
		cutouts[14].x = 192;
		cutouts[14].y = 614;
		if (cutouts[14].onLayout) cutouts[14].onLayout();
	}
	if (!cutouts[15] && cutouts.elementFactory) {
		cutouts[15] = cutouts.elementFactory(15,undefined);
	}
	if (cutouts[15]) {
		BronteSistersCutouts_broDino1.call(cutouts[15] as IBronteSistersCutouts_broDino1);
		cutouts[15].x = 75.5;
		cutouts[15].y = 392.5;
		if (cutouts[15].onLayout) cutouts[15].onLayout();
	}
	if (!cutouts[16] && cutouts.elementFactory) {
		cutouts[16] = cutouts.elementFactory(16,undefined);
	}
	if (cutouts[16]) {
		BronteSistersCutouts_broBoatBack1.call(cutouts[16] as IBronteSistersCutouts_broBoatBack1);
		cutouts[16].x = 201;
		cutouts[16].y = 179;
		if (cutouts[16].onLayout) cutouts[16].onLayout();
	}
	if (!cutouts[17] && cutouts.elementFactory) {
		cutouts[17] = cutouts.elementFactory(17,undefined);
	}
	if (cutouts[17]) {
		BronteSistersCutouts_broBicycle1.call(cutouts[17] as IBronteSistersCutouts_broBicycle1);
		cutouts[17].x = 833;
		cutouts[17].y = 654.5;
		if (cutouts[17].onLayout) cutouts[17].onLayout();
	}
	if (!cutouts[18] && cutouts.elementFactory) {
		cutouts[18] = cutouts.elementFactory(18,undefined);
	}
	if (cutouts[18]) {
		BronteSistersCutouts_broBgPizza11.call(cutouts[18] as IBronteSistersCutouts_broBgPizza11);
		cutouts[18].x = 154.5;
		cutouts[18].y = 526.25;
		if (cutouts[18].onLayout) cutouts[18].onLayout();
	}
	if (!cutouts[19] && cutouts.elementFactory) {
		cutouts[19] = cutouts.elementFactory(19,undefined);
	}
	if (cutouts[19]) {
		BronteSistersCutouts_broBgLibrary11.call(cutouts[19] as IBronteSistersCutouts_broBgLibrary11);
		cutouts[19].x = 19.55;
		cutouts[19].y = 952.6;
		if (cutouts[19].onLayout) cutouts[19].onLayout();
	}
	if (!cutouts[20] && cutouts.elementFactory) {
		cutouts[20] = cutouts.elementFactory(20,undefined);
	}
	if (cutouts[20]) {
		BronteSistersCutouts_broBgGarden31.call(cutouts[20] as IBronteSistersCutouts_broBgGarden31);
		cutouts[20].x = 796;
		cutouts[20].y = 471;
		if (cutouts[20].onLayout) cutouts[20].onLayout();
	}
	if (!cutouts[21] && cutouts.elementFactory) {
		cutouts[21] = cutouts.elementFactory(21,undefined);
	}
	if (cutouts[21]) {
		BronteSistersCutouts_broBgGarden21.call(cutouts[21] as IBronteSistersCutouts_broBgGarden21);
		cutouts[21].x = 834.5;
		cutouts[21].y = 500;
		if (cutouts[21].onLayout) cutouts[21].onLayout();
	}
	if (!cutouts[22] && cutouts.elementFactory) {
		cutouts[22] = cutouts.elementFactory(22,undefined);
	}
	if (cutouts[22]) {
		BronteSistersCutouts_broBgGarden11.call(cutouts[22] as IBronteSistersCutouts_broBgGarden11);
		cutouts[22].x = 797;
		cutouts[22].y = 463.5;
		if (cutouts[22].onLayout) cutouts[22].onLayout();
	}
	if (!cutouts[23] && cutouts.elementFactory) {
		cutouts[23] = cutouts.elementFactory(23,undefined);
	}
	if (cutouts[23]) {
		BronteSistersCutouts_broBgGarden41.call(cutouts[23] as IBronteSistersCutouts_broBgGarden41);
		cutouts[23].x = 812;
		cutouts[23].y = 545.5;
		if (cutouts[23].onLayout) cutouts[23].onLayout();
	}
	if (!cutouts[24] && cutouts.elementFactory) {
		cutouts[24] = cutouts.elementFactory(24,undefined);
	}
	if (cutouts[24]) {
		BronteSistersCutouts_broBgCastle1.call(cutouts[24] as IBronteSistersCutouts_broBgCastle1);
		cutouts[24].x = 440.5;
		cutouts[24].y = 409.5;
		if (cutouts[24].onLayout) cutouts[24].onLayout();
	}
	if (!cutouts[25] && cutouts.elementFactory) {
		cutouts[25] = cutouts.elementFactory(25,undefined);
	}
	if (cutouts[25]) {
		BronteSistersCutouts_broBCostume31.call(cutouts[25] as IBronteSistersCutouts_broBCostume31);
		cutouts[25].x = 832.5;
		cutouts[25].y = 455.5;
		if (cutouts[25].onLayout) cutouts[25].onLayout();
	}
	if (!cutouts[26] && cutouts.elementFactory) {
		cutouts[26] = cutouts.elementFactory(26,undefined);
	}
	if (cutouts[26]) {
		BronteSistersCutouts_broBCostume21.call(cutouts[26] as IBronteSistersCutouts_broBCostume21);
		cutouts[26].x = 570;
		cutouts[26].y = 455.5;
		if (cutouts[26].onLayout) cutouts[26].onLayout();
	}
	if (!cutouts[27] && cutouts.elementFactory) {
		cutouts[27] = cutouts.elementFactory(27,undefined);
	}
	if (cutouts[27]) {
		BronteSistersCutouts_broBCostume11.call(cutouts[27] as IBronteSistersCutouts_broBCostume11);
		cutouts[27].x = 729;
		cutouts[27].y = 341.5;
		if (cutouts[27].onLayout) cutouts[27].onLayout();
	}
	if (!cutouts[28] && cutouts.elementFactory) {
		cutouts[28] = cutouts.elementFactory(28,undefined);
	}
	if (cutouts[28]) {
		BronteSistersCutouts_broBCostume01.call(cutouts[28] as IBronteSistersCutouts_broBCostume01);
		cutouts[28].x = 828.5;
		cutouts[28].y = 419.5;
		if (cutouts[28].onLayout) cutouts[28].onLayout();
	}
	if (!cutouts[29] && cutouts.elementFactory) {
		cutouts[29] = cutouts.elementFactory(29,undefined);
	}
	if (cutouts[29]) {
		BronteSistersCutouts_broBalloonBack1.call(cutouts[29] as IBronteSistersCutouts_broBalloonBack1);
		cutouts[29].x = 659.5;
		cutouts[29].y = 313.5;
		if (cutouts[29].onLayout) cutouts[29].onLayout();
	}
	return this;
}
function BronteSistersCutouts_broYCostume31(this: IBronteSistersCutouts_broYCostume31) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [75.35,164.60,117.55,46.20,225.95,-14.10,368.25,-7.30,466.65,47.80,524.05,165.10,582.65,175.20,584.00,232.15,563.30,271.30,518.30,268.20,474.45,359.25,417.15,408.40,454.10,448.65,500.25,449.45,520.55,506.95,496.10,558.20,444.40,564.50,405.90,532.30,397.45,562.75,405.10,610.95,443.35,632.50,445.05,676.05,308.55,711.20,216.20,696.10,198.00,627.95,204.10,543.15,173.80,576.45,116.25,573.45,82.75,529.40,102.60,488.65,113.95,454.65,160.15,449.25,192.60,415.75,122.30,358.40,76.90,275.10,23.90,302.40,-15.50,249.40,-15.30,221.55,-13.95,190.35];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broYCostume3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 568.00;
	sprite.height = 695.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_broYCostume3_poly(this: IBronteSistersCutouts_broYCostume3_poly) {
	return this;
}
function BronteSistersCutouts_broYCostume3(this: IBronteSistersCutouts_broYCostume3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-y-costume-3.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broYCostume21(this: IBronteSistersCutouts_broYCostume21) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [47.40,104.25,101.10,109.00,135.80,47.40,252.70,-9.45,372.70,-7.85,465.85,39.50,508.50,93.20,563.40,77.80,585.25,129.20,571.70,190.70,539.45,193.45,519.55,287.45,464.30,369.55,416.90,401.15,431.15,535.40,412.20,568.55,440.60,592.25,442.20,647.50,319.00,664.85,238.45,645.90,232.15,600.10,249.55,568.55,217.10,537.80,238.45,405.90,145.30,345.90,94.75,266.90,88.45,216.40,17.40,235.20,-14.25,179.95,-10.05,154.60,-6.30,121.65];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broYCostume2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 569.00;
	sprite.height = 649.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol1(this: IBronteSistersCutouts_Symbol1) {
	return this;
}
function BronteSistersCutouts_broYCostume2(this: IBronteSistersCutouts_broYCostume2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-y-costume-2.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broYCostume11(this: IBronteSistersCutouts_broYCostume11) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [69.95,59.35,125.20,75.65,187.75,13.85,304.00,-17.85,416.95,12.75,466.50,53.40,535.10,26.80,577.15,34.45,589.90,100.70,579.70,146.55,505.80,147.80,507.05,248.45,453.55,359.30,440.80,433.15,444.65,500.65,424.25,529.95,466.30,546.50,463.55,603.25,392.40,620.40,327.45,606.40,252.25,626.80,193.65,610.20,182.20,572.00,219.15,537.60,193.65,510.85,194.95,439.50,174.55,397.45,166.90,343.95,117.20,275.20,100.65,168.20,19.10,186.05,-11.45,136.35,-9.30,104.85,-5.65,71.55];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broYCostume1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 573.00;
	sprite.height = 610.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol2(this: IBronteSistersCutouts_Symbol2) {
	return this;
}
function BronteSistersCutouts_broYCostume1(this: IBronteSistersCutouts_broYCostume1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-y-costume-1.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broYCostume01(this: IBronteSistersCutouts_broYCostume01) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [73.40,31.65,175.35,-4.05,366.95,-17.30,480.10,6.15,496.40,27.55,482.10,268.10,573.85,236.50,595.25,294.55,574.85,409.70,505.55,446.40,513.70,517.75,486.20,564.65,435.25,608.50,473.95,644.15,466.85,695.10,433.20,755.25,458.65,804.15,495.35,815.40,509.65,859.20,487.20,887.75,402.60,885.70,335.35,859.20,291.50,885.70,203.85,889.75,151.85,856.70,149.75,825.10,196.15,819.20,217.20,788.45,238.50,758.30,198.75,670.65,198.75,633.95,220.15,612.55,185.50,586.05,147.80,574.85,121.30,527.95,129.45,487.20,26.50,468.80,17.35,410.70,-13.25,364.85,-9.15,302.70,40.80,283.30,98.90,293.50,45.90,65.25];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broYCostume0.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 582.00;
	sprite.height = 878.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol3(this: IBronteSistersCutouts_Symbol3) {
	return this;
}
function BronteSistersCutouts_broYCostume0(this: IBronteSistersCutouts_broYCostume0) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-y-costume-0.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broXCostume31(this: IBronteSistersCutouts_broXCostume31) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [-1.65,195.00,65.30,97.55,228.55,-13.25,273.95,-17.35,343.25,24.35,393.40,-14.05,428.10,-12.40,428.10,20.70,465.30,46.30,490.90,93.40,543.75,146.30,583.40,233.05,573.50,275.20,537.95,288.45,478.45,276.85,476.80,361.10,441.25,421.45,379.30,469.40,422.25,609.05,415.65,647.05,404.10,661.95,410.70,677.65,446.25,695.80,445.40,733.85,415.65,753.70,346.25,757.00,314.00,766.10,244.60,763.60,206.55,742.95,205.75,715.70,220.60,676.85,188.40,648.75,193.35,601.60,224.75,474.35,160.30,433.85,117.30,428.10,77.65,365.25,85.90,295.85,18.20,309.90,-5.75,296.70,-8.85,284.70,-13.20,272.70];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broXCostume3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 573.00;
	sprite.height = 752.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol4(this: IBronteSistersCutouts_Symbol4) {
	return this;
}
function BronteSistersCutouts_broXCostume3(this: IBronteSistersCutouts_broXCostume3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-x-costume-3.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broXCostume21(this: IBronteSistersCutouts_broXCostume21) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [240.15,52.85,230.00,15.60,245.60,-11.60,291.90,-10.10,320.15,73.80,369.35,142.55,434.90,194.05,434.25,226.20,384.75,226.15,381.40,317.80,349.95,358.60,289.70,408.80,326.50,555.35,315.80,588.15,288.40,611.55,331.20,623.60,345.25,645.70,333.90,684.50,249.55,698.55,182.65,704.55,137.15,693.20,109.05,677.15,107.05,645.70,134.45,614.90,107.70,600.20,94.30,567.40,105.70,533.95,120.40,438.90,133.15,410.15,69.55,370.00,32.15,366.70,-3.35,323.85,-14.70,262.95,7.35,221.45,14.05,154.60,43.50,109.10,2.70,64.30,7.35,9.40,58.25,2.70,96.35,68.95,144.30,57.75,192.65,47.50];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broXCostume2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 424.00;
	sprite.height = 693.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol5(this: IBronteSistersCutouts_Symbol5) {
	return this;
}
function BronteSistersCutouts_broXCostume2(this: IBronteSistersCutouts_broXCostume2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-x-costume-2.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broXCostume11(this: IBronteSistersCutouts_broXCostume11) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [43.55,106.35,46.75,54.80,105.30,48.90,141.80,117.60,189.60,101.50,174.00,55.85,203.45,49.35,190.10,-10.20,225.00,-12.30,256.70,92.90,294.80,95.05,287.30,44.60,314.70,23.10,353.35,31.15,361.95,73.05,401.15,63.95,449.65,127.90,447.60,202.65,465.80,252.45,524.35,245.00,534.45,273.95,466.45,296.85,469.85,331.15,441.55,366.15,490.00,416.65,467.80,444.25,418.00,398.50,394.45,435.50,361.45,455.70,355.40,510.20,389.05,617.90,368.85,683.85,405.90,708.10,407.25,747.15,376.25,768.70,307.60,772.05,253.10,782.15,169.60,762.60,127.90,755.20,105.70,728.95,103.70,700.00,81.45,692.60,80.10,661.65,61.25,645.50,59.95,615.90,115.80,623.30,113.80,608.50,86.20,601.75,85.50,572.80,151.45,574.80,166.25,503.50,121.15,515.60,110.40,486.00,164.95,465.80,121.85,436.85,92.90,459.75,66.00,442.25,86.85,405.90,65.30,372.90,4.05,401.85,-17.50,378.30,43.10,337.90,32.30,308.95,44.45,300.20,54.55,219.45,5.40,210.00,3.40,177.05,72.05,182.40,83.45,170.75,94.55,157.90];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broXCostume1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 522.00;
	sprite.height = 767.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol6(this: IBronteSistersCutouts_Symbol6) {
	return this;
}
function BronteSistersCutouts_broXCostume1(this: IBronteSistersCutouts_broXCostume1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-x-costume-1.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broXCostume01(this: IBronteSistersCutouts_broXCostume01) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [34.85,48.15,72.65,57.15,62.75,18.90,107.45,-12.00,171.90,-7.30,190.80,77.75,253.05,97.10,240.20,53.70,260.35,27.50,302.05,28.80,314.05,64.05,344.65,61.30,371.30,86.25,395.55,159.05,397.55,272.25,404.30,320.70,390.15,375.95,361.85,409.65,307.95,454.80,307.95,496.60,336.95,599.00,331.55,638.75,312.70,667.05,348.40,687.25,353.80,727.05,328.20,749.30,263.50,756.00,215.65,766.15,143.55,757.35,114.60,739.20,111.20,708.85,128.75,671.10,107.85,662.35,89.65,628.65,101.75,588.20,132.10,455.50,69.45,422.45,35.05,420.45,-6.05,375.30,-11.45,299.85,8.10,266.80,15.50,198.75,47.85,149.60,35.70,120.60,6.70,111.20,3.05,66.60];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broXCostume0.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 388.00;
	sprite.height = 750.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol7(this: IBronteSistersCutouts_Symbol7) {
	return this;
}
function BronteSistersCutouts_broXCostume0(this: IBronteSistersCutouts_broXCostume0) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-x-costume-0.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broFloorRock21(this: IBronteSistersCutouts_broFloorRock21) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [93.80,11.95,184.90,-13.15,302.40,0.05,385.55,39.65,476.65,68.70,479.30,110.95,448.95,126.80,209.95,132.05,4.00,125.45,-14.45,101.70,-8.85,84.20,-1.25,64.75];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broFloorRock2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 467.00;
	sprite.height = 116.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol8(this: IBronteSistersCutouts_Symbol8) {
	return this;
}
function BronteSistersCutouts_broFloorRock2(this: IBronteSistersCutouts_broFloorRock2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-floor-rock-2.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broFloorRock11(this: IBronteSistersCutouts_broFloorRock11) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [25.10,43.60,62.05,31.75,149.70,-8.85,262.75,-13.15,368.35,33.05,457.30,72.65,458.20,102.65,414.55,118.85,278.60,129.45,150.50,132.05,6.60,122.85,-10.55,107.00,-7.90,76.60];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broFloorRock1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 446.00;
	sprite.height = 116.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol9(this: IBronteSistersCutouts_Symbol9) {
	return this;
}
function BronteSistersCutouts_broFloorRock1(this: IBronteSistersCutouts_broFloorRock1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-floor-rock-1.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broFloorRock01(this: IBronteSistersCutouts_broFloorRock01) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [-10.85,79.65,19.80,55.15,85.85,38.15,167.55,-0.70,264.20,-14.95,329.55,-6.10,461.65,61.95,478.65,97.35,469.15,122.55,303.00,132.10,143.00,129.35,12.30,122.55,-10.15,108.25];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broFloorRock0.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 467.00;
	sprite.height = 116.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol10(this: IBronteSistersCutouts_Symbol10) {
	return this;
}
function BronteSistersCutouts_broFloorRock0(this: IBronteSistersCutouts_broFloorRock0) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-floor-rock-0.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broFloorQuicksand1(this: IBronteSistersCutouts_broFloorQuicksand1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [58.25,-12.35,152.10,2.75,294.45,3.85,362.40,-5.85,454.10,20.00,517.75,13.55,675.20,36.20,913.60,43.75,997.70,35.10,1129.30,13.55,1342.85,12.45,1415.10,27.55,1502.50,11.40,1617.90,-5.85,1713.90,15.70,1699.85,340.35,-3.20,337.15,-9.70,3.85];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broFloorQuicksand.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1702.00;
	sprite.height = 354.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol11(this: IBronteSistersCutouts_Symbol11) {
	return this;
}
function BronteSistersCutouts_broFloorQuicksand(this: IBronteSistersCutouts_broFloorQuicksand) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-floor-quicksand.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broFloorPudding1(this: IBronteSistersCutouts_broFloorPudding1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [55.20,12.65,176.10,-8.50,253.15,-4.65,338.85,17.15,413.70,7.60,514.45,18.50,604.25,22.55,675.00,10.30,777.05,2.15,922.65,21.20,983.90,11.70,1031.55,13.05,1064.20,22.55,1162.10,25.30,1281.85,4.90,1352.65,6.25,1464.20,22.55,1518.65,18.50,1604.40,0.80,1677.80,0.80,1676.45,330.05,-9.50,332.75,-11.60,171.85,-13.90,10.45];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broFloorPudding.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1664.00;
	sprite.height = 313.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol12(this: IBronteSistersCutouts_Symbol12) {
	return this;
}
function BronteSistersCutouts_broFloorPudding(this: IBronteSistersCutouts_broFloorPudding) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-floor-pudding.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broFloorLava1(this: IBronteSistersCutouts_broFloorLava1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [103.35,19.80,146.05,29.35,287.00,28.25,339.45,19.20,481.90,16.60,509.20,8.65,580.40,6.05,651.65,-7.15,809.10,16.60,856.55,16.60,911.95,5.15,947.15,6.90,983.20,15.70,1058.85,19.20,1096.65,6.90,1149.40,5.15,1220.65,17.45,1270.75,11.30,1326.20,-0.15,1396.55,-3.65,1429.05,-1.00,1466.90,7.80,1531.95,10.40,1574.20,17.45,1677.10,22.75,1674.45,289.20,-7.00,290.05,-14.60,5.20];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broFloorLava.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1664.00;
	sprite.height = 270.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol13(this: IBronteSistersCutouts_Symbol13) {
	return this;
}
function BronteSistersCutouts_broFloorLava(this: IBronteSistersCutouts_broFloorLava) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-floor-lava.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broFloorIce1(this: IBronteSistersCutouts_broFloorIce1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [150.05,-7.10,283.75,8.90,322.40,10.00,400.80,6.70,448.25,10.00,480.25,17.75,557.55,21.05,632.65,18.85,700.35,5.80,806.35,6.65,942.40,11.95,1074.85,19.90,1126.95,15.50,1219.70,15.50,1290.35,19.05,1379.60,8.45,1415.80,10.20,1528.00,10.20,1575.65,8.45,1677.25,17.25,1676.35,327.25,-11.45,327.25,-15.15,8.10];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broFloorIce.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1664.00;
	sprite.height = 308.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol14(this: IBronteSistersCutouts_Symbol14) {
	return this;
}
function BronteSistersCutouts_broFloorIce(this: IBronteSistersCutouts_broFloorIce) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-floor-ice.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broDino1(this: IBronteSistersCutouts_broDino1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [82.50,185.00,10.05,156.05,-13.35,122.60,14.50,40.15,110.35,16.75,206.15,-14.45,244.05,-5.50,286.35,-8.85,356.55,10.10,441.25,59.10,479.15,46.85,583.85,32.35,686.35,36.80,764.35,61.35,832.25,69.15,977.10,99.20,1065.10,102.55,1245.60,98.10,1357.05,104.80,1484.05,124.85,1594.35,162.70,1690.20,197.25,1797.15,238.50,1869.55,277.50,1910.80,319.80,1906.35,348.80,1879.60,354.35,1778.20,316.50,1667.90,291.95,1624.45,279.70,1499.65,268.55,1290.20,273.00,1227.80,286.40,1059.55,388.90,1014.95,392.25,1040.60,439.05,1078.50,482.40,1126.40,514.70,1165.40,620.60,1184.35,655.10,1185.45,698.55,1163.15,703.05,1126.40,755.40,1040.60,762.10,1001.60,762.10,1001.60,725.30,1017.20,709.70,1062.90,701.90,1078.50,678.50,1066.25,621.70,1033.90,584.95,984.90,564.85,940.30,560.40,873.45,524.75,845.60,495.80,814.40,477.95,797.70,495.80,811.10,519.20,833.35,542.60,833.35,573.80,820.00,600.55,808.85,705.25,789.90,706.35,748.70,749.85,714.15,749.85,685.20,759.85,623.95,764.30,598.30,748.70,596.10,708.60,632.85,695.25,684.10,684.10,727.55,639.50,744.25,588.25,693.00,533.65,639.55,477.95,625.05,407.75,626.15,367.65,538.15,357.65,516.95,367.65,470.15,359.85,449.00,381.00,406.65,385.50,395.50,372.10,368.80,373.20,364.35,339.80,355.40,308.60,393.30,296.35,440.10,297.45,395.55,269.65,356.55,259.60,303.05,265.20,275.20,261.85,200.55,299.70,122.55,318.65,76.90,308.65,34.55,277.45,34.55,246.25,83.60,224.00];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broDino.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1897.00;
	sprite.height = 751.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol15(this: IBronteSistersCutouts_Symbol15) {
	return this;
}
function BronteSistersCutouts_broDino(this: IBronteSistersCutouts_broDino) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-dino.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBoatBack1(this: IBronteSistersCutouts_broBoatBack1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [468.00,889.35,475.05,879.15,442.00,778.45,426.30,654.90,430.20,528.25,456.95,392.15,431.00,359.90,507.30,274.95,485.30,272.60,483.60,239.15,1219.60,286.65,1226.50,155.10,1261.15,156.10,1264.10,232.25,1264.40,391.00,1266.40,563.10,1294.60,546.30,1299.75,511.20,1335.15,514.95,1460.10,411.60,1509.40,421.15,1515.35,539.85,1553.90,686.20,1620.85,802.50,1654.60,808.45,1656.60,834.30,1434.20,917.70,1440.20,935.55,1526.55,939.50,1532.50,973.25,1523.55,980.20,1515.60,1152.95,1499.75,1188.70,1441.15,1193.65,472.40,1183.50,440.65,1170.05,397.30,969.45,356.60,916.60,-6.40,783.65,-5.85,762.90,-5.65,742.25];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [39.95,772.65,83.30,790.30,458.55,391.80,219.75,825.65,261.50,838.50,503.90,390.55,463.60,370.70,438.10,353.60];
	}
	if (!polygons[2] && polygons.elementFactory) {
		polygons[2] = polygons.elementFactory(2,undefined);
	}
	if (polygons[2]) {
		polygons[2] = [912.35,112.40,847.30,104.60,608.05,251.55,532.65,248.95,786.20,91.60,739.40,72.10,739.40,37.00,856.40,48.70,925.35,5.80,926.65,-15.00,969.55,-9.80,965.65,11.00,1030.65,68.20,1108.70,79.90,1111.30,112.40,1084.00,122.80,1228.30,252.85,1256.90,221.65,1489.70,380.30,1523.50,376.40,1530.00,407.60,1509.20,425.80,1466.25,415.40,1355.75,342.60,1293.10,340.95,1258.20,375.10,1203.60,285.35,1018.95,121.50,961.75,118.90,948.75,273.65,923.40,272.85,898.05,271.05];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broBoatBack.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1646.00;
	sprite.height = 1178.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_broBoatBack_poly0(this: IBronteSistersCutouts_broBoatBack_poly0) {
	return this;
}
function BronteSistersCutouts_broBoatBack_poly1(this: IBronteSistersCutouts_broBoatBack_poly1) {
	return this;
}
function BronteSistersCutouts_broBoatBack_poly2(this: IBronteSistersCutouts_broBoatBack_poly2) {
	return this;
}
function BronteSistersCutouts_broBoatBack(this: IBronteSistersCutouts_broBoatBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-boat-back.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBicycle1(this: IBronteSistersCutouts_broBicycle1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [62.65,46.55,43.00,34.90,44.80,-10.75,145.90,-5.20,147.65,38.50,127.95,54.60,173.60,95.75,184.30,74.25,276.45,84.10,323.85,77.85,382.00,110.95,398.10,152.10,382.90,206.65,339.10,237.05,280.95,237.05,251.40,216.45,235.30,186.05,217.40,199.45,159.25,195.00,151.20,169.95,127.95,212.90,85.00,240.60,30.45,235.25,-7.10,190.50,-12.50,125.25,19.70,75.15,62.65,65.30];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broBicycle.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 382.00;
	sprite.height = 227.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol16(this: IBronteSistersCutouts_Symbol16) {
	return this;
}
function BronteSistersCutouts_broBicycle(this: IBronteSistersCutouts_broBicycle) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bicycle.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgPizza11(this: IBronteSistersCutouts_broBgPizza11) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [113.15,81.40,193.00,78.30,282.90,95.35,288.30,23.30,353.40,-7.70,441.00,-13.15,517.70,-2.30,540.95,-7.70,563.45,-46.45,675.45,-124.75,790.45,-180.30,835.25,-183.25,862.55,-189.10,894.75,-187.15,926.90,-195.90,963.95,-188.10,1005.85,-190.05,1021.45,-181.30,1065.30,-181.30,1156.90,-133.55,1180.30,-123.80,1251.10,-75.55,1291.10,-43.70,1311.70,-8.70,1355.40,15.00,1386.00,85.60,1454.70,78.10,1550.30,89.35,1614.65,111.20,1620.25,181.15,1611.50,258.60,1672.10,256.10,1736.45,277.35,1742.05,322.30,1742.05,364.15,1732.10,392.25,1733.35,442.85,1740.20,475.95,1728.35,485.95,1745.20,588.35,1748.35,638.35,1736.45,660.20,1602.80,664.00,1459.75,674.60,1379.80,674.60,1330.45,679.60,1275.50,676.45,1179.30,670.20,1158.05,648.95,1157.40,617.75,1173.05,600.25,1188.65,537.80,1156.15,498.45,1156.15,465.35,1171.15,456.60,1166.15,432.85,1175.55,373.50,1183.05,361.00,1174.90,336.05,1192.40,309.80,1188.05,286.70,1168.65,247.95,1153.05,211.15,1149.30,183.05,1129.30,173.05,1114.35,146.15,1111.20,128.05,1043.10,70.60,1008.75,57.45,995.60,43.75,953.75,41.85,925.65,50.60,884.45,41.85,851.95,47.50,834.45,66.20,813.20,70.60,740.80,128.70,732.70,159.95,717.05,177.45,703.35,182.45,698.35,214.20,687.70,231.70,683.95,249.80,658.35,304.80,677.05,324.15,672.70,362.85,682.65,404.70,686.40,455.30,697.65,474.65,697.05,502.80,668.30,535.25,681.45,600.85,697.05,622.10,695.80,650.20,677.10,667.70,573.40,678.30,468.45,674.60,355.40,669.60,261.70,667.75,180.50,671.45,99.30,667.10,18.75,672.70,-1.85,665.20,-10.60,644.60,-5.00,612.10,-4.95,580.25,7.55,500.30,1.30,490.90,0.05,469.70,5.05,458.45,5.65,409.10,-3.75,387.85,1.25,352.25,-3.75,329.15,5.65,300.40,40.60,285.45,46.25,259.20,40.00,242.95,40.00,219.20,50.60,181.75,44.45,121.10,52.10,101.20];
	}
	const sprites = this.sprites;
	if (!sprites[0] && sprites.elementFactory) {
		sprites[0] = sprites.elementFactory(0,undefined);
	}
	if (sprites[0]) {
		BronteSistersCutouts_broBgPizza4.call(sprites[0] as IBronteSistersCutouts_broBgPizza4);
		sprites[0].x = 548.1;
		sprites[0].y = -180.35;
		sprites[0].width = 399.00;
		sprites[0].height = 343.00;
		if (sprites[0].onLayout) sprites[0].onLayout();
	}
	if (!sprites[1] && sprites.elementFactory) {
		sprites[1] = sprites.elementFactory(1,undefined);
	}
	if (sprites[1]) {
		BronteSistersCutouts_broBgPizza2.call(sprites[1] as IBronteSistersCutouts_broBgPizza2);
		sprites[1].x = 1306;
		sprites[1].y = 90.75;
		sprites[1].width = 433.00;
		sprites[1].height = 567.00;
		if (sprites[1].onLayout) sprites[1].onLayout();
	}
	if (!sprites[2] && sprites.elementFactory) {
		sprites[2] = sprites.elementFactory(2,undefined);
	}
	if (sprites[2]) {
		BronteSistersCutouts_broBgPizza3.call(sprites[2] as IBronteSistersCutouts_broBgPizza3);
		sprites[2].x = 359.8;
		sprites[2].y = 3.75;
		sprites[2].width = 359.00;
		sprites[2].height = 660.00;
		if (sprites[2].onLayout) sprites[2].onLayout();
	}
	if (!sprites[3] && sprites.elementFactory) {
		sprites[3] = sprites.elementFactory(3,undefined);
	}
	if (sprites[3]) {
		BronteSistersCutouts_broBgPizza4.call(sprites[3] as IBronteSistersCutouts_broBgPizza4);
		sprites[3].x = 1306.1;
		sprites[3].y = -180.25;
		sprites[3].width = -399.00;
		sprites[3].height = 343.00;
		if (sprites[3].onLayout) sprites[3].onLayout();
	}
	if (!sprites[4] && sprites.elementFactory) {
		sprites[4] = sprites.elementFactory(4,undefined);
	}
	if (sprites[4]) {
		BronteSistersCutouts_broBgPizza3.call(sprites[4] as IBronteSistersCutouts_broBgPizza3);
		sprites[4].x = 1494.4;
		sprites[4].y = 3.85;
		sprites[4].width = -359.00;
		sprites[4].height = 660.00;
		if (sprites[4].onLayout) sprites[4].onLayout();
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broBgPizza1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 561.00;
	sprite.height = 660.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol17(this: IBronteSistersCutouts_Symbol17) {
	return this;
}
function BronteSistersCutouts_broBgPizza4(this: IBronteSistersCutouts_broBgPizza4) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-pizza4.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgPizza2(this: IBronteSistersCutouts_broBgPizza2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-pizza2.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgPizza1(this: IBronteSistersCutouts_broBgPizza1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-pizza1.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgPizza3(this: IBronteSistersCutouts_broBgPizza3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-pizza3.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgLibrary11(this: IBronteSistersCutouts_broBgLibrary11) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [20.50,22.10,24.45,-8.65,283.05,-13.40,272.05,-41.00,290.15,-91.45,280.70,-122.20,297.25,-160.05,354.80,-160.80,355.35,-563.85,368.30,-588.70,422.60,-613.05,463.50,-615.85,491.50,-618.30,899.35,-504.25,906.30,-489.35,904.30,133.00,884.45,148.90,724.60,147.90,668.05,181.65,620.40,183.65,614.45,202.50,525.10,249.15,310.70,247.15,295.80,239.20,260.15,248.20,95.35,243.25,91.35,214.45,6.00,211.45,4.00,133.05,14.95,120.15,-8.90,85.40,-7.80,58.95,-6.30,31.55];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [1497.90,-613.60,1526.05,-606.55,1533.10,-581.00,1574.70,-548.35,1606.70,-548.35,1623.25,-536.50,1629.90,-515.45,1629.40,-183.40,1671.95,-182.90,1691.90,-177.80,1701.15,-202.90,1707.30,-240.30,1691.40,-261.30,1692.45,-298.20,1796.95,-336.60,1951.70,-336.60,1975.25,-328.40,1975.80,-304.30,1988.60,-264.35,1983.45,-239.75,1987.55,-210.55,1980.90,-180.30,1996.80,-145.00,1994.75,-110.15,1983.45,-97.85,1998.30,-69.70,2000.35,-31.25,1988.05,-13.30,2007.60,-1.00,2017.85,32.35,2007.55,61.00,1992.15,80.50,2001.90,94.30,1999.85,171.70,2011.10,180.30,2011.10,243.85,1988.60,248.45,1784.65,249.00,1651.95,224.45,1637.60,210.60,1635.55,185.50,1445.45,185.50,1431.65,241.30,1412.15,246.45,1227.20,247.95,1160.05,206.50,1151.85,188.55,1149.80,168.55,1133.90,165.00,1130.85,152.15,1058.60,151.65,1039.15,137.85,1034.75,-443.25,1037.95,-471.45,1042.60,-478.95,1048.35,-487.10];
	}
	const sprites = this.sprites;
	if (!sprites[0] && sprites.elementFactory) {
		sprites[0] = sprites.elementFactory(0,undefined);
	}
	if (sprites[0]) {
		BronteSistersCutouts_broBgLibrary3.call(sprites[0] as IBronteSistersCutouts_broBgLibrary3);
		sprites[0].x = 1048.7;
		sprites[0].y = -600.8;
		sprites[0].width = 569.00;
		sprites[0].height = 740.00;
		if (sprites[0].onLayout) sprites[0].onLayout();
	}
	if (!sprites[1] && sprites.elementFactory) {
		sprites[1] = sprites.elementFactory(1,undefined);
	}
	if (sprites[1]) {
		BronteSistersCutouts_broBgLibrary2.call(sprites[1] as IBronteSistersCutouts_broBgLibrary2);
		sprites[1].x = 368.2;
		sprites[1].y = -608;
		sprites[1].width = 524.00;
		sprites[1].height = 747.00;
		if (sprites[1].onLayout) sprites[1].onLayout();
	}
	if (!sprites[2] && sprites.elementFactory) {
		sprites[2] = sprites.elementFactory(2,undefined);
	}
	if (sprites[2]) {
		BronteSistersCutouts_broBgLibrary4.call(sprites[2] as IBronteSistersCutouts_broBgLibrary4);
		sprites[2].x = 1425;
		sprites[2].y = -324;
		sprites[2].width = 580.00;
		sprites[2].height = 561.00;
		if (sprites[2].onLayout) sprites[2].onLayout();
	}
	if (!sprites[3] && sprites.elementFactory) {
		sprites[3] = sprites.elementFactory(3,undefined);
	}
	if (sprites[3]) {
		BronteSistersCutouts_broBgLibrary5.call(sprites[3] as IBronteSistersCutouts_broBgLibrary5);
		sprites[3].x = 280.4;
		sprites[3].y = -147.7;
		sprites[3].width = 284.00;
		sprites[3].height = 345.00;
		if (sprites[3].onLayout) sprites[3].onLayout();
	}
	if (!sprites[4] && sprites.elementFactory) {
		sprites[4] = sprites.elementFactory(4,undefined);
	}
	if (sprites[4]) {
		BronteSistersCutouts_broBgLibrary6.call(sprites[4] as IBronteSistersCutouts_broBgLibrary6);
		sprites[4].x = 1134.3;
		sprites[4].y = -53;
		sprites[4].width = 402.00;
		sprites[4].height = 290.00;
		if (sprites[4].onLayout) sprites[4].onLayout();
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broBgLibrary1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 719.00;
	sprite.height = 237.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol18(this: IBronteSistersCutouts_Symbol18) {
	return this;
}
function BronteSistersCutouts_Symbol19(this: IBronteSistersCutouts_Symbol19) {
	return this;
}
function BronteSistersCutouts_broBgLibrary3(this: IBronteSistersCutouts_broBgLibrary3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-library3.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgLibrary2(this: IBronteSistersCutouts_broBgLibrary2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-library2.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgLibrary4(this: IBronteSistersCutouts_broBgLibrary4) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-library4.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgLibrary5(this: IBronteSistersCutouts_broBgLibrary5) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-library5.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgLibrary1(this: IBronteSistersCutouts_broBgLibrary1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-library1.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgLibrary6(this: IBronteSistersCutouts_broBgLibrary6) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-library6.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgGarden31(this: IBronteSistersCutouts_broBgGarden31) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [150.90,-6.90,160.85,61.55,181.70,70.50,180.70,119.15,155.90,153.85,197.60,145.95,213.45,108.20,318.70,124.10,351.45,214.45,381.25,228.30,389.15,286.90,406.05,291.85,411.00,310.70,441.80,322.60,453.70,362.35,470.55,377.20,459.65,428.85,463.60,490.40,443.75,496.35,444.80,527.10,422.90,546.95,427.85,596.55,319.70,601.50,160.85,583.65,150.95,607.50,105.25,605.50,83.45,562.80,87.40,532.05,78.50,506.20,28.85,515.15,11.95,498.30,13.95,466.50,37.75,451.65,48.70,406.95,-5.90,392.05,-9.90,360.30,27.85,337.45,23.85,304.70,38.75,279.90,17.90,268.05,18.90,236.25,36.80,219.40,33.80,167.75,12.95,139.95,15.95,102.25,53.65,75.45,64.55,20.85,79.50,-9.95];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broBgGarden3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 456.00;
	sprite.height = 594.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol30(this: IBronteSistersCutouts_Symbol30) {
	return this;
}
function BronteSistersCutouts_broBgGarden3(this: IBronteSistersCutouts_broBgGarden3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-garden3.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgGarden21(this: IBronteSistersCutouts_broBgGarden21) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [215.40,-6.90,228.30,31.80,254.15,22.85,287.90,31.80,285.90,69.55,269.00,100.30,317.65,86.40,338.50,92.35,347.45,117.20,370.30,129.10,373.25,193.60,391.10,207.50,388.20,235.30,326.60,254.15,323.60,339.50,313.70,356.35,301.80,435.80,312.70,468.55,294.85,502.25,264.05,506.25,251.15,495.35,188.60,498.30,188.60,537.05,133.00,547.00,114.20,538.00,70.50,537.05,31.80,518.15,17.90,402.05,-10.90,390.10,-10.90,364.30,4.95,349.40,-8.90,336.50,-4.95,294.85,52.60,297.80,62.55,271.00,97.30,276.95,130.05,270.00,124.10,184.65,98.30,166.75,95.30,86.35,110.20,58.55,134.00,50.65,142.95,30.75,161.80,23.80,184.65,-11.85];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broBgGarden2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 379.00;
	sprite.height = 536.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol31(this: IBronteSistersCutouts_Symbol31) {
	return this;
}
function BronteSistersCutouts_broBgGarden2(this: IBronteSistersCutouts_broBgGarden2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-garden2.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgGarden11(this: IBronteSistersCutouts_broBgGarden11) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [385.20,-1.95,392.15,62.55,413.00,70.50,415.95,116.15,382.20,152.90,427.90,152.90,448.70,228.80,466.05,267.95,445.75,289.85,433.85,351.40,466.60,376.25,464.60,419.90,428.85,422.90,414.00,504.30,383.20,515.20,342.50,596.55,298.85,601.55,279.00,622.40,253.15,623.40,243.25,610.45,150.95,612.45,85.40,591.60,41.75,551.90,25.85,522.10,12.95,519.15,5.00,492.35,-12.85,481.40,0.05,420.90,3.45,372.70,30.80,352.40,38.55,289.90,58.60,285.90,68.55,253.15,92.35,253.15,111.20,225.35,110.25,182.65,146.95,167.80,167.40,122.30,242.25,141.95,246.20,107.25,269.05,81.40,284.70,79.70,286.70,42.70,310.75,-8.90];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broBgGarden1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 454.00;
	sprite.height = 609.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol32(this: IBronteSistersCutouts_Symbol32) {
	return this;
}
function BronteSistersCutouts_broBgGarden1(this: IBronteSistersCutouts_broBgGarden1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-garden1.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgGarden41(this: IBronteSistersCutouts_broBgGarden41) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [309.80,-10.95,308.80,19.90,281.90,92.65,374.50,67.75,391.45,87.60,347.65,126.50,423.35,127.50,425.30,153.35,356.60,171.30,413.35,206.15,441.25,247.00,434.30,269.95,407.40,267.90,380.50,242.05,348.65,435.25,323.75,460.15,293.85,457.15,285.90,447.20,262.95,458.15,131.50,433.25,75.75,450.15,47.85,448.20,32.90,434.25,12.00,433.25,-14.90,397.40,-1.95,317.70,-11.90,219.10,6.00,212.15,-7.95,169.30,71.75,108.60,121.55,102.60,149.45,111.55,113.55,59.75,115.55,33.85,145.45,39.85,190.25,83.65,212.20,6.00,239.05,12.95,244.20,72.40,282.90,-12.95];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broBgGarden4.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 424.00;
	sprite.height = 445.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol33(this: IBronteSistersCutouts_Symbol33) {
	return this;
}
function BronteSistersCutouts_broBgGarden4(this: IBronteSistersCutouts_broBgGarden4) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-garden4.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBgCastle1(this: IBronteSistersCutouts_broBgCastle1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [-7.30,687.60,93.10,676.40,94.70,-13.50,318.35,-10.40,361.00,91.55,359.95,131.10,780.20,133.15,788.55,90.50,833.20,-11.45,1066.20,-10.40,1067.30,668.85,1174.45,684.45,1175.50,722.95,1072.50,721.95,849.90,729.20,818.65,717.75,329.75,718.80,299.60,728.15,147.60,727.80,-5.20,728.15];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broBgCastle.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 1167.00;
	sprite.height = 717.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol23(this: IBronteSistersCutouts_Symbol23) {
	return this;
}
function BronteSistersCutouts_broBgCastle(this: IBronteSistersCutouts_broBgCastle) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-bg-castle.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBCostume31(this: IBronteSistersCutouts_broBCostume31) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [13.45,83.80,118.70,-3.70,251.35,-13.90,322.20,22.60,361.35,86.95,373.70,168.05,395.20,185.80,397.35,223.90,371.55,264.70,347.40,269.55,282.95,337.75,318.40,391.45,316.80,428.00,281.35,458.05,271.70,524.65,286.75,547.20,321.65,562.25,324.85,603.05,302.30,621.30,242.15,622.40,197.05,639.05,126.70,632.05,102.00,616.50,109.50,569.75,90.20,562.25,92.85,465.60,66.65,446.75,56.95,417.75,72.55,366.75,105.30,337.75,64.45,306.05,28.50,304.95,1.65,288.35,-15.55,243.75,-4.85,220.95,5.35,198.15];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broBCostume3.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 383.00;
	sprite.height = 625.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol24(this: IBronteSistersCutouts_Symbol24) {
	return this;
}
function BronteSistersCutouts_broBCostume3(this: IBronteSistersCutouts_broBCostume3) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-b-costume3.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBCostume21(this: IBronteSistersCutouts_broBCostume21) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [210.35,118.60,270.10,128.70,293.65,54.70,331.50,11.80,414.80,-12.60,493.05,-11.75,579.70,26.95,618.40,84.15,629.30,126.20,699.05,118.65,916.10,139.70,920.30,169.15,879.95,212.85,841.25,241.45,810.15,291.10,777.35,328.10,765.55,332.30,721.80,388.65,682.30,413.90,597.30,442.50,548.50,451.75,558.60,534.20,572.05,555.25,570.35,583.85,546.80,597.30,502.20,606.55,463.50,594.80,448.35,620.85,386.95,641.05,340.70,628.45,333.10,596.45,341.55,569.55,361.70,558.60,348.25,544.30,355.85,440.80,201.95,406.30,151.45,366.75,121.20,324.70,105.20,319.65,49.70,241.50,43.80,215.40,16.85,201.95,-11.75,160.70,-9.20,145.45,-6.70,129.55];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broBCostume2.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 908.00;
	sprite.height = 625.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol25(this: IBronteSistersCutouts_Symbol25) {
	return this;
}
function BronteSistersCutouts_broBCostume2(this: IBronteSistersCutouts_broBCostume2) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-b-costume2.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBCostume11(this: IBronteSistersCutouts_broBCostume11) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [-9.45,94.85,28.45,51.65,76.95,48.45,143.30,90.60,204.45,207.55,267.65,187.55,332.95,185.45,346.65,95.90,400.40,6.30,446.75,-16.85,496.30,3.15,521.55,47.40,516.30,70.60,488.90,75.85,472.05,34.75,452.05,22.15,423.60,34.75,389.85,83.25,368.80,182.30,414.10,192.80,461.50,232.85,468.90,273.95,464.70,299.25,498.40,383.50,493.15,427.75,480.50,456.20,480.50,484.65,524.75,485.70,538.45,461.45,565.85,464.60,600.60,496.25,596.40,558.40,557.40,582.65,534.20,578.40,517.35,558.40,464.70,564.70,433.05,607.90,461.50,666.90,465.75,723.85,443.65,756.50,444.70,778.60,475.25,792.30,482.60,831.30,449.95,853.45,384.60,851.30,341.40,867.15,280.30,859.75,260.30,843.95,260.30,803.90,274.00,787.05,268.70,745.95,206.55,782.85,153.90,786.00,126.50,753.35,123.30,699.20,153.90,643.75,135.95,639.55,118.05,665.90,58.00,652.20,33.75,609.00,49.55,575.25,28.50,522.60,39.00,455.15,69.55,409.85,101.20,399.35,117.00,300.30,148.60,248.65,174.95,225.50,113.80,114.90,68.50,87.50,41.10,90.65,29.50,109.60,28.45,145.45,10.95,145.30,-7.35,144.35];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broBCostume1.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 590.00;
	sprite.height = 853.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol26(this: IBronteSistersCutouts_Symbol26) {
	return this;
}
function BronteSistersCutouts_broBCostume1(this: IBronteSistersCutouts_broBCostume1) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-b-costume1.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBCostume01(this: IBronteSistersCutouts_broBCostume01) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [-14.60,233.50,2.65,144.60,59.70,69.00,107.45,47.80,123.40,9.30,173.85,-18.55,238.85,-3.95,272.00,42.45,338.35,74.30,382.10,136.65,399.35,213.60,395.40,265.35,407.30,285.25,398.05,330.35,307.80,416.55,351.55,444.40,354.20,465.60,305.15,575.70,289.20,579.70,299.85,628.80,335.65,640.70,350.25,668.60,333.00,700.40,279.95,712.35,210.95,697.75,130.65,710.95,74.90,691.80,70.95,649.85,120.80,624.15,38.50,608.90,-3.95,608.90,-2.75,557.95,70.30,486.85,67.65,443.05,110.10,413.85,58.40,381.70,0.50,341.45];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broBCostume0.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 391.00;
	sprite.height = 697.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol27(this: IBronteSistersCutouts_Symbol27) {
	return this;
}
function BronteSistersCutouts_broBCostume0(this: IBronteSistersCutouts_broBCostume0) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-b-costume0.png", 0.000, 0.000);
	return this;
}
function BronteSistersCutouts_broBalloonBack1(this: IBronteSistersCutouts_broBalloonBack1) {
	const polygons = this.polygons;
	if (!polygons[0] && polygons.elementFactory) {
		polygons[0] = polygons.elementFactory(0,undefined);
	}
	if (polygons[0]) {
		polygons[0] = [24.50,888.85,-6.35,862.25,-12.70,809.10,13.85,718.70,3.25,691.10,5.35,650.70,165.90,568.80,381.75,560.30,683.70,567.75,728.35,594.35,732.60,623.05,717.70,647.50,744.30,732.55,735.80,788.90,713.45,813.35,687.95,817.60,672.00,866.50,536.95,920.75,311.55,919.65,105.30,906.90,74.45,881.40];
	}
	if (!polygons[1] && polygons.elementFactory) {
		polygons[1] = polygons.elementFactory(1,undefined);
	}
	if (polygons[1]) {
		polygons[1] = [683.70,-9.55,684.75,17.05,541.20,291.35,558.20,315.80,559.30,350.90,686.80,574.10,638.95,570.90,528.35,380.60,478.40,395.50,519.85,569.85,475.20,566.65,438.00,404.00,367.80,407.20,308.30,402.95,260.45,570.90,220.05,572.00,265.75,401.85,197.70,384.85,74.45,619.80,11.70,654.90,160.55,363.60,154.15,335.95,160.55,299.80,6.40,15.95,7.50,-9.55];
	}
	const sprite = this.sprite;
	BronteSistersCutouts_broBalloonBack.call(this.sprite);
	sprite.x = 0;
	sprite.y = 0;
	sprite.width = 729.00;
	sprite.height = 909.00;
	if (sprite.onLayout) sprite.onLayout();
	return this;
}
function BronteSistersCutouts_Symbol28(this: IBronteSistersCutouts_Symbol28) {
	return this;
}
function BronteSistersCutouts_Symbol29(this: IBronteSistersCutouts_Symbol29) {
	return this;
}
function BronteSistersCutouts_broBalloonBack(this: IBronteSistersCutouts_broBalloonBack) {
	if (this.setLayoutTexture) this.setLayoutTexture("bro-balloon-back.png", 0.000, 0.000);
	return this;
}
interface IBronteSistersCutoutsArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IBronteSistersCutoutsContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IBronteSistersCutoutsSprite extends IBronteSistersCutoutsContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IBronteSistersCutoutsText extends IBronteSistersCutoutsContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IBronteSistersCutoutsPolygon extends Array<number> {
}
interface IBronteSistersCutouts {
	readonly cutouts: IBronteSistersCutoutsArray<IBronteSistersCutouts_broYCostume31|IBronteSistersCutouts_broYCostume21|IBronteSistersCutouts_broYCostume11|IBronteSistersCutouts_broYCostume01|IBronteSistersCutouts_broXCostume31|IBronteSistersCutouts_broXCostume21|IBronteSistersCutouts_broXCostume11|IBronteSistersCutouts_broXCostume01|IBronteSistersCutouts_broFloorRock21|IBronteSistersCutouts_broFloorRock11|IBronteSistersCutouts_broFloorRock01|IBronteSistersCutouts_broFloorQuicksand1|IBronteSistersCutouts_broFloorPudding1|IBronteSistersCutouts_broFloorLava1|IBronteSistersCutouts_broFloorIce1|IBronteSistersCutouts_broDino1|IBronteSistersCutouts_broBoatBack1|IBronteSistersCutouts_broBicycle1|IBronteSistersCutouts_broBgPizza11|IBronteSistersCutouts_broBgLibrary11|IBronteSistersCutouts_broBgGarden31|IBronteSistersCutouts_broBgGarden21|IBronteSistersCutouts_broBgGarden11|IBronteSistersCutouts_broBgGarden41|IBronteSistersCutouts_broBgCastle1|IBronteSistersCutouts_broBCostume31|IBronteSistersCutouts_broBCostume21|IBronteSistersCutouts_broBCostume11|IBronteSistersCutouts_broBCostume01|IBronteSistersCutouts_broBalloonBack1>;
}
interface IBronteSistersCutouts_broYCostume31 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_broYCostume3_poly>;
	readonly sprite: IBronteSistersCutouts_broYCostume3;
}
interface IBronteSistersCutouts_broYCostume3_poly extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broYCostume3 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broYCostume21 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol1>;
	readonly sprite: IBronteSistersCutouts_broYCostume2;
}
interface IBronteSistersCutouts_Symbol1 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broYCostume2 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broYCostume11 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol2>;
	readonly sprite: IBronteSistersCutouts_broYCostume1;
}
interface IBronteSistersCutouts_Symbol2 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broYCostume1 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broYCostume01 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol3>;
	readonly sprite: IBronteSistersCutouts_broYCostume0;
}
interface IBronteSistersCutouts_Symbol3 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broYCostume0 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broXCostume31 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol4>;
	readonly sprite: IBronteSistersCutouts_broXCostume3;
}
interface IBronteSistersCutouts_Symbol4 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broXCostume3 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broXCostume21 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol5>;
	readonly sprite: IBronteSistersCutouts_broXCostume2;
}
interface IBronteSistersCutouts_Symbol5 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broXCostume2 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broXCostume11 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol6>;
	readonly sprite: IBronteSistersCutouts_broXCostume1;
}
interface IBronteSistersCutouts_Symbol6 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broXCostume1 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broXCostume01 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol7>;
	readonly sprite: IBronteSistersCutouts_broXCostume0;
}
interface IBronteSistersCutouts_Symbol7 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broXCostume0 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broFloorRock21 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol8>;
	readonly sprite: IBronteSistersCutouts_broFloorRock2;
}
interface IBronteSistersCutouts_Symbol8 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broFloorRock2 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broFloorRock11 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol9>;
	readonly sprite: IBronteSistersCutouts_broFloorRock1;
}
interface IBronteSistersCutouts_Symbol9 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broFloorRock1 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broFloorRock01 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol10>;
	readonly sprite: IBronteSistersCutouts_broFloorRock0;
}
interface IBronteSistersCutouts_Symbol10 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broFloorRock0 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broFloorQuicksand1 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol11>;
	readonly sprite: IBronteSistersCutouts_broFloorQuicksand;
}
interface IBronteSistersCutouts_Symbol11 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broFloorQuicksand extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broFloorPudding1 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol12>;
	readonly sprite: IBronteSistersCutouts_broFloorPudding;
}
interface IBronteSistersCutouts_Symbol12 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broFloorPudding extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broFloorLava1 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol13>;
	readonly sprite: IBronteSistersCutouts_broFloorLava;
}
interface IBronteSistersCutouts_Symbol13 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broFloorLava extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broFloorIce1 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol14>;
	readonly sprite: IBronteSistersCutouts_broFloorIce;
}
interface IBronteSistersCutouts_Symbol14 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broFloorIce extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broDino1 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol15>;
	readonly sprite: IBronteSistersCutouts_broDino;
}
interface IBronteSistersCutouts_Symbol15 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broDino extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBoatBack1 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_broBoatBack_poly0|IBronteSistersCutouts_broBoatBack_poly1|IBronteSistersCutouts_broBoatBack_poly2>;
	readonly sprite: IBronteSistersCutouts_broBoatBack;
}
interface IBronteSistersCutouts_broBoatBack_poly0 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBoatBack_poly1 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBoatBack_poly2 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBoatBack extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBicycle1 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol16>;
	readonly sprite: IBronteSistersCutouts_broBicycle;
}
interface IBronteSistersCutouts_Symbol16 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBicycle extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgPizza11 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol17>;
	readonly sprites: IBronteSistersCutoutsArray<IBronteSistersCutouts_broBgPizza4|IBronteSistersCutouts_broBgPizza2|IBronteSistersCutouts_broBgPizza3>;
	readonly sprite: IBronteSistersCutouts_broBgPizza1;
}
interface IBronteSistersCutouts_Symbol17 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBgPizza4 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgPizza2 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgPizza1 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgPizza3 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgLibrary11 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol18|IBronteSistersCutouts_Symbol19>;
	readonly sprites: IBronteSistersCutoutsArray<IBronteSistersCutouts_broBgLibrary3|IBronteSistersCutouts_broBgLibrary2|IBronteSistersCutouts_broBgLibrary4|IBronteSistersCutouts_broBgLibrary5|IBronteSistersCutouts_broBgLibrary6>;
	readonly sprite: IBronteSistersCutouts_broBgLibrary1;
}
interface IBronteSistersCutouts_Symbol18 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_Symbol19 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBgLibrary3 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgLibrary2 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgLibrary4 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgLibrary5 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgLibrary1 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgLibrary6 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgGarden31 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol30>;
	readonly sprite: IBronteSistersCutouts_broBgGarden3;
}
interface IBronteSistersCutouts_Symbol30 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBgGarden3 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgGarden21 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol31>;
	readonly sprite: IBronteSistersCutouts_broBgGarden2;
}
interface IBronteSistersCutouts_Symbol31 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBgGarden2 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgGarden11 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol32>;
	readonly sprite: IBronteSistersCutouts_broBgGarden1;
}
interface IBronteSistersCutouts_Symbol32 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBgGarden1 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgGarden41 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol33>;
	readonly sprite: IBronteSistersCutouts_broBgGarden4;
}
interface IBronteSistersCutouts_Symbol33 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBgGarden4 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBgCastle1 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol23>;
	readonly sprite: IBronteSistersCutouts_broBgCastle;
}
interface IBronteSistersCutouts_Symbol23 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBgCastle extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBCostume31 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol24>;
	readonly sprite: IBronteSistersCutouts_broBCostume3;
}
interface IBronteSistersCutouts_Symbol24 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBCostume3 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBCostume21 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol25>;
	readonly sprite: IBronteSistersCutouts_broBCostume2;
}
interface IBronteSistersCutouts_Symbol25 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBCostume2 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBCostume11 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol26>;
	readonly sprite: IBronteSistersCutouts_broBCostume1;
}
interface IBronteSistersCutouts_Symbol26 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBCostume1 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBCostume01 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol27>;
	readonly sprite: IBronteSistersCutouts_broBCostume0;
}
interface IBronteSistersCutouts_Symbol27 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBCostume0 extends IBronteSistersCutoutsSprite {
}
interface IBronteSistersCutouts_broBalloonBack1 extends IBronteSistersCutoutsContainer {
	readonly polygons: IBronteSistersCutoutsArray<IBronteSistersCutouts_Symbol28|IBronteSistersCutouts_Symbol29>;
	readonly sprite: IBronteSistersCutouts_broBalloonBack;
}
interface IBronteSistersCutouts_Symbol28 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_Symbol29 extends IBronteSistersCutoutsPolygon {
}
interface IBronteSistersCutouts_broBalloonBack extends IBronteSistersCutoutsSprite {
}
